import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=7971067c&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style1 from "./Menu.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Menu.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971067c",
  null
  
)

export default component.exports